import { createContext, useState, ReactNode } from "react";
import {
  AnapreDataObject,
  CodiciProgrammaPGMEDT,
  formattedAnapreDataObject,
  formattedBancheDataObject,
  FormattedCodiciProgramma,
  formattedCodIvaDataObject,
  formattedMansioDataObject,
  FormattedMednotDataObject,
  FormattedMedpgmpDataObject,
  FormattedMedPreslDataObject,
  formattedPanotetDataObject,
  FormattedRagggpDataObject,
  FormattedRaggrDataObject,
  formattedSaldoCollaboratoriDataObject,
  FormattedUnitaErogatriciDataObject,
  MansioDataObject,
  MedintDoctorData,
  PanotetDataObject,
} from "../../../services/medintInterfaces";
import {
  CommonFieldsData,
  generalResearch,
  referti,
  performance,
  specialities,
  typology,
  medPresl,
  medpgmp,
  eqmed,
  mednot,
} from "../../../networking";
import dayjs from "dayjs";

interface MedintContextType {
  data: any;
  setData: (data: any) => void;
  selectedDoctor: any;
  setSelectedDoctor: (doctor: any) => void;
  doctorsData: MedintDoctorData[] | undefined;
  setDoctorsData: (doctorsData: MedintDoctorData[] | undefined) => void;
  doctorAgenda: any;
  setDoctorAgenda: (doctorsData: any) => void;
  specialitiesSPECIALITA: any;
  setSpecialitiesSPECIALITA: (specialitiesSPECIALITA: any) => void;
  typologiesTIPOLOGIE: any;
  setTypologiesTIPOLOGIE: (typologiesTIPOLOGIE: any) => void;
  typologiesRICERCHE: any;
  setTypologiesRICERCHE: (typologiesRICERCHE: any) => void;
  performancePRESTAZIONI: any;
  setPerformacePRESTAZIONI: (performancePRESTAZIONI: any) => void;
  prestazioniANAPRE: any;
  setPrestazioniANAPRE: (prestazioniANAPRE: any) => void;
  dettagliNotePANOTET: any;
  setDettagliNotePANOTET: (notePanotet: any) => void;
  stampaRaggrPARAGGR: any;
  setStampaRaggrPARAGGR: (stampaPARAGGR: any) => void;
  importiMEDPRESL: any;
  setImportiMEDPRESL: (importiMEDPRESL: any) => void;
  raggruppamentoPARAGGGP: any;
  setRaggruppamentoPARAGGGP: (raggruppamentoPARAGGGP: any) => void;
  codiciProgrammaPGMEDT: any;
  setCodiciProgrammaPGMEDT: (codiciPGMEDT: any) => void;
  listaUnitaErogatrici: any;
  setListaUnitaErogatrici: (unitaErog: any) => void;
  fullViewAgendaForm: boolean;
  setFullViewAgendaForm: (showView: boolean) => void;
  validateData: () => void;
  requestTypologiesTIPOLOGIA: () => void;
  requestSpecialitiesListSPECIALITA: () => void;
  requestPerformancePRESTAZIONI: () => void;
  requestPerformanceANAPRE: () => void;
  requestDettagliNotePANOTET: () => void;
  requestRaggruppamentoStampaPARAGGR: () => void;
  requestMansioni: () => void;
  requestEquipeEQUMED: () => void;
  handlerMEDPGMP: (request: FormattedMedpgmpDataObject) => void;
  requestImportiMEDPRESL: (request: FormattedMedPreslDataObject) => void;
  requestCodiciProgramma: (
    dataRifParam?: string | null,
    fixFltParam?: string | null,
  ) => any;
  requestRaggruppamentoRAGGGP: () => void;
  // requestTypologiesRICERCHE: () => void;
  prestazioniAbbinate: { [key: string]: any }[];
  setPrestazioniAbbinate: (prestazioniAbbinateLista: any) => void;
  prestazioniErogabili: { [key: string]: any }[];
  setPrestazioniErogabili: (
    prestazioniErogabiliLista: { [key: string]: any }[],
  ) => void;
  listaMansioni: formattedMansioDataObject[] | null;
  setListaMansioni: (mansioniLista: formattedMansioDataObject[] | null) => void;
  listaBanche: formattedBancheDataObject[] | null;
  setListaBanche: (mansioniLista: formattedBancheDataObject[] | null) => void;
  listaCodIva: formattedCodIvaDataObject[] | null;
  setListaCodIva: (mansioniLista: formattedCodIvaDataObject[] | null) => void;
  listaSaldoCollaboratori: formattedSaldoCollaboratoriDataObject[] | null;
  setListaSaldoCollaboratori: (
    mansioniLista: formattedSaldoCollaboratoriDataObject[] | null,
  ) => void;
  noteAggiuntiveMedico: any;
  setNoteAggiuntiveMedico: (note: any) => void;
  requestNoteAggiuntiveMedico: (request?: FormattedMednotDataObject | null) => any;
}

const MedintDataContext = createContext<MedintContextType | undefined>(
  undefined,
);

const MedintContextWrapper = ({ children }: { children: ReactNode }) => {
  //NOTA: Converrebbe convertire useStates qua presenti in useMemo

  const [dataTransfer, setDataTransfer] = useState([] as any);
  const [doctorsData, setDoctorsData] = useState<
    MedintDoctorData[] | undefined
  >([]);

  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);

  const [refertiData, setRefertiData] = useState<any>(null);

  const [doctorAgenda, setDoctorAgenda] = useState<any>(null);

  // il prefisso ad esempio "specialities" serve per indicare quale delle chiamate fetch valorizza lo state corrispondente
  // poiché vengono fornite liste di oggetti simili ma con diverse funzionalità mirate
  const [specialitiesSPECIALITA, setSpecialitiesSPECIALITA] =
    useState<any>(null);
  const [typologiesTIPOLOGIE, setTypologiesTIPOLOGIE] = useState<any>(null);
  const [performancePRESTAZIONI, setPerformacePRESTAZIONI] =
    useState<any>(null);
  const [typologiesRICERCHE, setTypologiesRICERCHE] = useState<any>(null);
  const [importiMEDPRESL, setImportiMEDPRESL] = useState<any>(null);
  const [noteAggiuntiveMedico, setNoteAggiuntiveMedico] = useState<any>(null);
  const [prestazioniANAPRE, setPrestazioniANAPRE] = useState<
    formattedAnapreDataObject[]
  >([]);

  const [dettagliNotePANOTET, setDettagliNotePANOTET] = useState<
    formattedPanotetDataObject[]
  >([]);

  const [codiciProgrammaPGMEDT, setCodiciProgrammaPGMEDT] = useState<
    FormattedCodiciProgramma[]
  >([]);

  const [stampaRaggrPARAGGR, setStampaRaggrPARAGGR] = useState<
    FormattedRaggrDataObject[]
  >([]);

  const [raggruppamentoPARAGGGP, setRaggruppamentoPARAGGGP] = useState<
    FormattedRagggpDataObject[]
  >([]);

  const [listaUnitaErogatrici, setListaUnitaErogatrici] = useState<
    FormattedUnitaErogatriciDataObject[]
  >([]);

  const [prestazioniErogabili, setPrestazioniErogabili] = useState<any>([]);

  const [listaMansioni, setListaMansioni] = useState<
    formattedMansioDataObject[] | null
  >([]);
  const [listaBanche, setListaBanche] = useState<
    formattedBancheDataObject[] | null
  >([]);
  const [listaCodIva, setListaCodIva] = useState<
    formattedCodIvaDataObject[] | null
  >([]);
  const [listaSaldoCollaboratori, setListaSaldoCollaboratori] = useState<
    formattedSaldoCollaboratoriDataObject[] | null
  >([]);

  const [prestazioniAbbinate, setPrestazioniAbbinate] = useState<any>([]);

  const [fullViewAgendaForm, setFullViewAgendaForm] = useState<boolean>(false);
  async function validateData() {
    const objectJsonRequest: CommonFieldsData = {
      tabella: "MEDINT",
      codice: "",
      filtro: "",
      applicazione: "",
      attivi: "0",
    };

    try {
      const doctorResponse = await generalResearch(objectJsonRequest);
      const doctors = doctorResponse.data.dati;

      setDoctorsData(doctors);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async function requestReferti() {
    const objectJsonRequest: CommonFieldsData = {
      codice: "",
      tipodoc: "LS",
    };

    try {
      const refertiResponse = await referti(objectJsonRequest);
      const tempReferti = refertiResponse.data.dati;

      setRefertiData(tempReferti);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async function requestTypologiesTIPOLOGIA() {
    try {
      const data = await typology({
        tipoAgenda: "",
        listino: "",
        specialita: "",
        prestazione: "",
        medico: "",
      });
      const typologiesList = data.data.dati;
      console.log({ typologiesList });
      setTypologiesTIPOLOGIE(typologiesList);
    } catch (error) {
      console.error("Error fetching TIPOLOGIE:", error);
    }
  }

  async function requestSpecialitiesListSPECIALITA() {
    try {
      const data = await specialities({
        tipoAgenda: "",
        listino: "",
        specialita: "",
        prestazione: "",
        medico: "",
      });
      const specialitiesList = data.data.dati;
      console.log({ specialitiesList });
      setSpecialitiesSPECIALITA(specialitiesList);
    } catch (error) {
      console.error("Error fetching SPECIALITA specialita:", error);
    }
  }

  async function requestPerformancePRESTAZIONI() {
    try {
      const data = await performance({
        tipoAgenda: "",
        listino: "",
        specialita: "",
        prestazione: "",
        medico: "",
      });
      const performancesList = data.data.dati;
      const found = performancesList.find((e : any) => e.PRESTAZIONE === "707");
      console.log({ found });
      console.log({ performancesList });
      setPerformacePRESTAZIONI(performancesList);
    } catch (error) {
      console.error("Error fetching PRESTAZIONI prestazioni:", error);
    }
  }

  async function requestPerformanceANAPRE() {
    try {
      const data = await generalResearch({
        tabella: "ANAPRE",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "0",
      });
      const prestazioniANAPREList: formattedAnapreDataObject[] =
        data.data.dati.map((e: AnapreDataObject, index: number) => {
          const tempObj: formattedAnapreDataObject = {
            id: index,
            idAnapre: e.pkey,
            prestazione: e.descrizione,
            codice: e.prestazione,
            specialita: e.specialit,
            tipologia: "",
            durata: "0",
          };
          return tempObj;
        });
      console.log({ prestazioniANAPREList });
      setPrestazioniANAPRE(prestazioniANAPREList);
    } catch (error) {
      console.error("Error fetching PRESTAZIONI ANAPRE:", error);
    }
  }

  async function requestCodiciProgramma(
    dataRifParam?: string | null,
    fixFltParam?: string | null,
  ) {
    try {
      const response = await generalResearch({
        tabella: "PGMEDT",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "1",
        dataRif: dataRifParam ?? dayjs().format("YYYY-MM-DD"),
        ...(fixFltParam != null && {
          filtriFissi: [
            {
              colFixFlt: "PGMEDT_CODICE",
              fixFlt: fixFltParam ?? "",
            },
          ],
        }),
      });
      const codiciProgramma: FormattedCodiciProgramma[] =
        response.data.dati.map((e: CodiciProgrammaPGMEDT, index: number) => {
          const tempObj: FormattedCodiciProgramma = {
            id: index,
            chiave: e.pkey,
            descrizione: e.descrizione,
            codProg: e["cod.programma"],
            dataIni: e["data inizio validit"],
            dataFin: e["data fine validit"],
            descRid: e["descr.ridotta"],
          };
          return tempObj;
        });
      console.log({ codiciProgramma });
      setCodiciProgrammaPGMEDT(codiciProgramma);
      return codiciProgramma;
    } catch (error) {
      console.error("Error fetching codici programma:", error);
    }
  }

  async function requestDettagliNotePANOTET() {
    try {
      const data = await generalResearch({
        tabella: "PANOTET",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "0",
      });
      const dettagliNoteList: formattedPanotetDataObject[] = data.data.dati.map(
        (e: PanotetDataObject, index: number) => {
          const tempObj: formattedPanotetDataObject = {
            id: index,
            codice: e.codice,
            descrizione: e.descrizione,
          };
          return tempObj;
        },
      );
      console.log({ dettagliNoteList });
      setDettagliNotePANOTET(dettagliNoteList);
    } catch (error) {
      console.error("Error fetching PRESTAZIONI ANAPRE:", error);
    }
  }

  async function requestMansioni() {
    try {
      const data = await generalResearch({
        tabella: "MANSIO",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "1",
      });
      const dettaglioMansioni: formattedMansioDataObject[] = data.data.dati.map(
        (e: MansioDataObject, index: number) => {
          const tempObj: formattedMansioDataObject = {
            id: index,
            pkey: e.pkey,
            codice: e.codice,
            descrizione: e.descrizione,
          };
          return tempObj;
        },
      );
      console.log({ dettaglioMansioni });
      setListaMansioni(dettaglioMansioni);
    } catch (error) {
      console.error("Error fetching PRESTAZIONI ANAPRE:", error);
    }
  }

  async function requestRaggruppamentoStampaPARAGGR() {
    try {
      const data = await generalResearch({
        tabella: "PARAGGR",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "0",
      });
      const dettagliRaggrList: FormattedRaggrDataObject[] = data.data.dati.map(
        (e: PanotetDataObject, index: number) => {
          const tempObj: formattedPanotetDataObject = {
            id: index,
            codice: e.codice,
            descrizione: e.descrizione,
          };
          return tempObj;
        },
      );
      console.log({ dettagliRaggrList });
      setStampaRaggrPARAGGR(dettagliRaggrList);
    } catch (error) {
      console.error("Error fetching Raggruppamento Stampe PARAGGR:", error);
    }
  }

  async function requestRaggruppamentoRAGGGP() {
    try {
      const response = await generalResearch({
        tabella: "RAGGGP",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "0",
      });
      const dettagliRAGGGP: FormattedRagggpDataObject[] =
        response.data.dati.map(
          (e: FormattedRagggpDataObject, index: number) => {
            const tempObj: FormattedRagggpDataObject = {
              id: index,
              codice: e.codice,
              descrizione: e.descrizione,
              "codice reg.": e["codice reg."],
            };
            return tempObj;
          },
        );
      console.log({ dettagliRAGGGP });
      setRaggruppamentoPARAGGGP(dettagliRAGGGP);
    } catch (error) {
      console.error("Error fetching Raggruppamento Stampe PARAGGR:", error);
    }
  }

  async function requestImportiMEDPRESL(request: FormattedMedPreslDataObject) {
    try {
      const data = await medPresl({
        idMedpresl: request.idMedpresl ?? null,
        crud: request.crud ?? null,
        idMedprest: request.idMedprest ?? null,
        dataIniValidita: request.dataIniValidita ?? null,
        importoListino: request.importoListino ?? null,
        importoPaz: request.importoPaz ?? null,
        importoEnte: request.importoEnte ?? null,
      });
      const medPreslList = data.data.dati;
      console.log({ medPreslList });
      setImportiMEDPRESL(medPreslList);
    } catch (error) {
      console.error("Error fetching IMPORTI:", error);
    }
  }

  async function requestNoteAggiuntiveMedico(
    request?: FormattedMednotDataObject | null,
  ) {
    try {
      const data = await mednot({
        crud: request?.crud ?? "r",
        medint_prgint: request?.medintPrgInt ?? "",
        aziendPrenotazione: request?.aziendaPrenotazione ?? "",
      });
      const noteAggiuntive = data.data.dati.mednot.MEDNOT_NOTE;
      console.log({noteAggiuntive});
      return noteAggiuntive;
    } catch (error) {
      console.error("Error fetching IMPORTI:", error);
    }
  }

  async function handlerMEDPGMP(request: FormattedMedpgmpDataObject) {
    try {
      const data = await medpgmp({
        crud: request?.crud ?? "",
        idMedpgm: request?.idMedpgm ?? "",
        idAnapre: request?.idAnapre ?? "",
        codiceTpgpre: request?.codiceTpgpre ?? "",
      });
      const response = data;
      console.log({ response });
    } catch (error) {
      console.error("Error sending create medpgmp:", error);
    }
  }

  async function requestEquipeEQUMED() {
    try {
      const data = await eqmed({
        crud: "r",
        prgint: selectedDoctor?.pkey ?? "",
      });
      const response = data;
      console.log({ response });
    } catch (error) {
      console.error("Error sending read equmed:", error);
    }
  }

  const prop = {
    data: dataTransfer,
    setData: setDataTransfer,
    doctorsData,
    setDoctorsData,
    selectedDoctor,
    setSelectedDoctor,
    specialitiesSPECIALITA,
    setSpecialitiesSPECIALITA,
    typologiesTIPOLOGIE,
    setTypologiesTIPOLOGIE,
    doctorAgenda,
    setDoctorAgenda,
    typologiesRICERCHE,
    setTypologiesRICERCHE,
    performancePRESTAZIONI,
    setPerformacePRESTAZIONI,
    validateData,
    requestSpecialitiesListSPECIALITA,
    requestTypologiesTIPOLOGIA,
    requestPerformancePRESTAZIONI,
    requestPerformanceANAPRE,
    requestDettagliNotePANOTET,
    requestRaggruppamentoStampaPARAGGR,
    requestImportiMEDPRESL,
    requestRaggruppamentoRAGGGP,
    requestCodiciProgramma,
    handlerMEDPGMP,
    requestEquipeEQUMED,
    requestMansioni,
    // requestTypologiesRICERCHE,
    prestazioniAbbinate,
    setPrestazioniAbbinate,
    prestazioniErogabili,
    setPrestazioniErogabili,
    prestazioniANAPRE,
    setPrestazioniANAPRE,
    dettagliNotePANOTET,
    setDettagliNotePANOTET,
    stampaRaggrPARAGGR,
    setStampaRaggrPARAGGR,
    importiMEDPRESL,
    setImportiMEDPRESL,
    raggruppamentoPARAGGGP,
    setRaggruppamentoPARAGGGP,
    codiciProgrammaPGMEDT,
    setCodiciProgrammaPGMEDT,
    listaUnitaErogatrici,
    setListaUnitaErogatrici,
    fullViewAgendaForm,
    setFullViewAgendaForm,
    listaMansioni,
    setListaMansioni,
    listaBanche,
    setListaBanche,
    listaCodIva,
    setListaCodIva,
    listaSaldoCollaboratori,
    setListaSaldoCollaboratori,
    noteAggiuntiveMedico,
    setNoteAggiuntiveMedico,
    requestNoteAggiuntiveMedico,
  };

  return (
    <MedintDataContext.Provider value={prop}>
      {children}
    </MedintDataContext.Provider>
  );
};

export { MedintContextWrapper, MedintDataContext };
